import React, { forwardRef } from "react";
import Link from "./Link";
import { isMarketingExternal, marketingHref } from "../utils/marketingLinks";

const MarketingLink = forwardRef(
  ({ marketingKey, className, children, openInNewTab, ...rest }, ref) => {
    if (isMarketingExternal()) {
      const newTabProps = openInNewTab
        ? { target: "_blank", rel: "noopener noreferrer" }
        : {};

      return (
        <a
          ref={ref}
          href={marketingHref(marketingKey)}
          className={className}
          {...newTabProps}
          {...rest}
        >
          {children}
        </a>
      );
    }

    return (
      <Link ref={ref} href={marketingHref(marketingKey)} className={className} {...rest}>
        {children}
      </Link>
    );
  },
);

MarketingLink.displayName = "MarketingLink";

export default MarketingLink;
